import { Box, IconButton, Tooltip } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import attachmentStripHandler from './AttachmentStripHandler';

/**
 * AttachmentStripBar — collapse toggle bar with attachment count and upload trigger.
 * All interactions routed via AttachmentStripHandler — no method props.
 * @param {object} props
 * @param {number} props.count - total number of attachments
 * @param {boolean} props.collapsed - current collapse state
 */
export default function AttachmentStripBar({ count, collapsed }) {
    return (
        <Box id="attachment-strip-bar" className="attachment-strip-bar">
            <AttachFileIcon className="attachment-strip-bar-icon" />
            <span className="attachment-strip-bar-count">{count}</span>

            {/* Upload trigger — opens UploadAttachmentDialog via handler */}
            <Tooltip title="Add attachment" placement="top">
                <IconButton onClick={attachmentStripHandler.handleOpenUpload} size="small" className="attachment-strip-upload-btn">
                    <AddIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            {/* Collapse toggle — only shown when entry has attachments */}
            {count > 0 && (
                <Tooltip title={collapsed ? 'Show attachments' : 'Hide attachments'} placement="top">
                    <IconButton onClick={attachmentStripHandler.handleToggleCollapse} size="small" className="attachment-strip-collapse-btn">
                        {collapsed ? <ExpandMoreIcon fontSize="small" /> : <ExpandLessIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
}
